import React from "react";
import CustomCheckbox from "./CustomCheckbox";
import { SET_DISABLE_STOP_LOSS, SET_DISABLE_STOP_LOSS_RENT } from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { disableFractionExchanges } from "../../../../utils/Utils";
import LeftRightForm from "./LeftRightForm";

const DisableStopLoss = (props)=>{
    const {rent, leftCol,rightCol} = props
    const newBot = useSelector((state) => state.createBot.newBot);
    const rentBot = useSelector((state) => state.createBot.rentBot);
    const {t} = useTranslation()
    const selectedExchange = newBot.exchange;
    const disableStopLossRent = isNaN(rentBot.stopLossDisabled)?0:parseInt(rentBot.stopLossDisabled);
    const disableStopLoss = isNaN(newBot.stopLossDisabled)?0:parseInt(newBot.stopLossDisabled);
    const dispatch = useDispatch()
    const setDisableStopLoss = (val) => {
        dispatch({
          type: rent?SET_DISABLE_STOP_LOSS_RENT:SET_DISABLE_STOP_LOSS,
          payload: val?1:0,
        });
      };
    return(<>
            <LeftRightForm 
            left={<></>}
            right={ <CustomCheckbox 
                val={rent?disableStopLossRent:disableStopLoss} 
                checked={rent?disableStopLossRent:disableStopLoss} 
                callback={setDisableStopLoss}
                label={t("dis-stop-loss")}
                id={'dis-stop-loss'}
                >
                </CustomCheckbox>}
                 leftCol={leftCol}
             rightCol={rightCol}
            >
            </LeftRightForm>
    </>)
}

export default DisableStopLoss;